<template>
  <div class="ListUsers">
    <HeaderPage>
      <el-button style="height: 44px; margin-left: 1rem" @click="() => { $router.push({name: 'records.users.create'})}" native-type="submit">Adicionar</el-button>
    </HeaderPage>
    <el-card v-loading="loadingPage">
      <FilterBox v-on:filter="listUsers" :currentPage="listData.meta ? listData.meta.pagination.current_page : 1" />
      <TableSimple :list-data="listData" @paginationClick="paginationClick" :dblclick="(el) => {$router.push({name: 'records.users.edit', params: { id: el.id }})}">
        <el-table-column prop="name" label="Nome" />
        <el-table-column prop="email" label="E-mail" />
        <el-table-column prop="type_account.name" label="Tipo da Conta" width="200" />
        <el-table-column prop="profile.name" label="Perfil de Acesso" width="200" />
        <el-table-column prop="status" label="Status" width="200">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 'active'" type="success">Ativo</el-tag>
            <el-tag  v-else type="warning">Desativado</el-tag>
          </template>
        </el-table-column>
        <el-table-column width="55">
          <template slot-scope="scope">
            <el-button v-if="$can('1') || scope.row.type_account_id == 5 " type="text" @click="() => {$router.push({name: 'records.users.edit', params: { id: scope.row.id }})}">
              <EditIcon size="1.2x" style="padding: 0 7px;"></EditIcon>
            </el-button>
          </template>
        </el-table-column>
      </TableSimple>
    </el-card>
  </div>
</template>

<script>
import HeaderPage from "@/app/components/HeaderPage";
import TableSimple from "@/app/components/Table/TableSimple";
import {EditIcon} from "vue-feather-icons";
import FilterBox from './_filterBox'
import {getUsers} from "@/app/domains/Records/services";
import {makeErrorFilds} from "@/app/plugins/utils";

export default {
  name: "ListUsers",
  components: {
    HeaderPage,
    TableSimple,
    EditIcon,
    FilterBox,
  },
  data () {
    return {
      loadingPage: true,
      listData: {},
      ruleForm: {
        searchInput: ''
      },
      filtros:{},
    }
  },
  methods: {
    init () {
      this.listUsers()
    },
    paginationClick (arg) {
      const newQueryString = this.filtros
        .replace(/[?&](page|per_page)=[^&]+/gi, "") // Remove as informações de "page" e "per_page"
        .replace(/^[?&]/, "");
      this.listUsers("?"+newQueryString+"&page=" + arg.page + `&per_page=${arg.meta.per_page}`);

    },
    async listUsers (query = '') {
      this.filtros = query;
      this.loadingPage = true
      try {
        let response = await getUsers(query)
        this.listData = response.data
      } catch (e) {
        this.error = makeErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    },
    clearSearch () {
      this.$set(this.ruleForm, 'searchInput', '')
      this.init()
    },
    searchTable () {
      this.listUsers('?name='+this.ruleForm.searchInput)
    },
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped>

</style>
